<div>
    <h2 mat-dialog-title *ngIf='data.title'>
        {{ data.title }}
    </h2>
    <syn-message-box color="warning_outlined" class="syn--margin-bottom" leftIcon="alert" *ngIf="missingRoles?.length > 0">
        Votre token contient plus de droits que le bot auquel il est rattaché. N'oubliez pas de changer les droits du
        BOT si nécessaire.<br />
        Liste des droits manquants sur le bot:
        <ul>
            <li *ngFor="let missingRole of missingRoles">{{ missingRole }}</li>
        </ul>
    </syn-message-box>

    <div mat-dialog-actions align="end" *ngIf='data.title'>
        <button mat-button mat-dialog-close>Fermer</button>
    </div>
</div>
